import * as React from "react";
import { Field } from "react-final-form";
import { Item } from "../modelo/ItemsListaDesplegabe";

export default class SelectorDesplegable extends React.Component<SelectorDesplegableProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            verOpciones: false,
            seleccionTodos: false
        };
    }

    render() {

        return (
            <Field name={this.props.name}
                parse={value => {
                    return value;
                }}>
                {({ input, meta }) => {
                    input.name = this.props.name;
                    return (
                        <div className="multiselect">
                            <div className="selectBox" onClick={() => this.abrirCerrarSelector()}>
                                <select style={{ height: "34px" }}>
                                    <option>Seleccione las Opciones</option>
                                </select>
                                <div className="overSelect" />
                            </div>
                            {this.renderOpciones(input)}
                            <span>
                                {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                            </span>
                        </div>
                    );
                }}
            </Field>
        );
    }

    renderOpciones = (input: any) => {
        const { listaDesplegable } = this.props;

        return (
            <div id="checkboxes" style={this.state.verOpciones ? { display: "block" } : { display: "none" }}>
                <label className="labelSelector" key={0} ><input className="inputSelector" type="checkbox" id={"0"}
                    onChange={() => this.seleccionTodos(input)} />
                    {this.state.seleccionTodos ? "NINGUNO" : "TODOS"}
                </label>
                {
                    listaDesplegable.map(item => {
                        return (
                            <label className="labelSelector" key={item.codigo} >
                                <input className="inputSelector"
                                    type="checkbox"
                                    checked={item.seleccionado}
                                    onChange={() => this.seleccion(item, input)}
                                />
                                {item.texto}
                            </label>
                        );
                    })
                }
            </div>
        );
    }

    seleccion = (item: Item, input: any) => {
        item.seleccionado = !item.seleccionado;
        this.guardarSeleccionados(input);
        this.renderSelector();
    }

    renderSelector = () => {
        this.setState({ verOpciones: false });
        this.setState({ verOpciones: true });
    }

    guardarSeleccionados = (input: any) => {
        const codigosSeleccionados = [];
        this.props.listaDesplegable.filter(item => item.seleccionado)
            .forEach(item => codigosSeleccionados.push(item.codigo));
        input.onChange(codigosSeleccionados);
    }

    seleccionTodos = (input: any) => {
        const seleccion = !this.state.seleccionTodos;
        this.setState({ seleccionTodos: seleccion });
        this.props.listaDesplegable.map(item => item.seleccionado = seleccion);
        this.guardarSeleccionados(input);
        this.renderSelector();
    }

    abrirCerrarSelector = () => {
        this.setState({ verOpciones: !this.state.verOpciones });
    }

} interface SelectorDesplegableProps {
    name: string,
    className?: string,
    listaDesplegable: Array<Item>
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/SelectorDesplegable.tsx